import { connect } from 'react-redux'
import { EditMenuConceptModal } from '@components/chef/edit'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state) => {
  const { chef, editMenuConcept, editMenuConceptModal, user } = state
  const { show } = editMenuConceptModal
  const errors = state.errors.menuConceptModal || {}

  const { allMenuItems = {} } = chef
  const {
    mainMenuItems = [],
    sideMenuItems = [],
    otherMenuItems = [],
  } = allMenuItems

  return {
    chefId: editMenuConcept.chefId,
    errors,
    locale: user.locale,
    mainMenuItems,
    menuConcept: editMenuConcept,
    otherMenuItems,
    sideMenuItems,
    show,
  }
}

const mapDispatchToProps = () => {
  const { ChefService, RestService, SettingsService, UIService } = services
  const { filterRemainingItems, pStateToReduxConcept } = presenters
  const {
    pCalculateConceptMargin,
    pGetMainMenuItems,
    pGetSideMenuItems,
    pGetOtherMenuItems,
    pMenuItemMargin,
    pRequestUpdateMenuConcept,
    pRequestSettings,
    pResponseMenuItems,
    pResponseSettings,
    pResponseConcepts,
    pRequestUpdateConceptImages,
    pSerializeLoadMenuItemsParams,
  } = presenters.Api
  const {
    DelayedUpdateConcept,
    DeleteMenuConcept,
    LoadAllChefMenuItemsIntoRedux,
    LoadSettings,
    RetryOnTimeout,
    SaveMenuConcept,
    GetConceptAvgPricePerPerson,
    GetConceptEstPricePerPerson,
  } = coordinators

  const { close } = UIService.EditMenuConcept
  const clearErrors = UIService.Errors.clear
  const { displayWarningMessage, displayFailureMessage } =
    UIService.FlashMessage
  const delayedUpdateConcept = DelayedUpdateConcept({
    ChefService,
    UIService,
    pStateToReduxConcept,
  })
  const deleteMenuConcept = DeleteMenuConcept({
    ChefService,
    RestService,
    UIService,
    pResponseConcepts,
    HandleError,
  })
  const loadAllChefMenuItems = LoadAllChefMenuItemsIntoRedux({
    ChefService,
    RestService,
    pResponseMenuItems,
    pSerializeLoadMenuItemsParams,
    HandleError,
  })
  const loadConceptsSettings = LoadSettings({
    RestService,
    SettingsService,
    pRequestSettings,
    pResponseSettings,
    RetryOnTimeout,
    HandleError,
  })('concepts')
  const saveMenuConcept = SaveMenuConcept({
    ChefService,
    RestService,
    UIService,
    pRequestUpdateMenuConcept,
    pResponseConcepts,
    pRequestUpdateConceptImages,
    HandleError,
  })
  const getAvgPricePerPerson = GetConceptAvgPricePerPerson({
    RestService,
    HandleError,
  })
  const getConceptEstPricePerPerson = GetConceptEstPricePerPerson({
    RestService,
    HandleError,
  })

  return {
    clearErrors,
    close,
    delayedUpdateConcept,
    deleteMenuConcept,
    filterRemainingItems,
    loadAllChefMenuItems,
    loadConceptsSettings,
    pCalculateConceptMargin,
    pGetMainMenuItems,
    pGetSideMenuItems,
    pGetOtherMenuItems,
    pMenuItemMargin,
    saveMenuConcept,
    displayWarningMessage,
    displayFailureMessage,
    getAvgPricePerPerson,
    getConceptEstPricePerPerson,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditMenuConceptModal)
